import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehiclesByGroupId } from '../../services/GroupsService';
import { FeaturesManagement } from '../../../featuresControl';
import { VehiclesResponse } from '../../types/Vehicles';

function useGetVehiclesByGroupById(id: string, fleetId: string, query?: string, enabled: boolean = true): UseQueryResult<VehiclesResponse> {
  return useQuery(
    ['group-vehicles', id, fleetId],
    async (): Promise<VehiclesResponse> => getVehiclesByGroupId(id, fleetId, query),
    {
      retry: 0,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && enabled,
    },
  );
}

export default useGetVehiclesByGroupById;
